import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

/**
 * Synchronise les filtres globaux (factory, etc.) avec un hook useInfiniteScroll.
 * Appelle handleUpdateParam pour chaque filtre global qui change après le mount.
 * Extensible : ajouter ici tout nouveau filtre global futur.
 */
export function useGlobalFilters(handleUpdateParam) {
  const userFactory = useSelector((state) => state.user_factory);
  const prevFactory = useRef(userFactory);

  useEffect(() => {
    if (prevFactory.current !== userFactory) {
      prevFactory.current = userFactory;
      handleUpdateParam('factory_id', userFactory || undefined);
    }
  }, [userFactory, handleUpdateParam]);
}
